import React, { Fragment, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Typography, Grid, Radio, RadioGroup, FormControlLabel, FormControl, Button } from '@material-ui/core';
import Questions from '../Questions';
import Timer from '../Timer';
import Constants from '../../Constants'
import useProfile from '../../Hooks/useProfile'
import Quiz from '../Quiz';
import { toast } from 'react-toastify'

const QuizCompo = React.memo(() => {

    const history = useHistory();

    const [question8, setQuestion8] = useState([]);
    const [disableQuestion, setDisableQuestion] = useState(false);

    const { loader, showLoader, hideLoader } = useProfile();

    // Set Answer8 State
    const [answer8, setAnswer8] = useState({
        question1: "", question2: "", question3: "", question4: "", question5: "", question6: "", question7: "",
        question8: "", question9: "", question10: "", question11: "", question12: "",
        ans1: "e", ans2: "d", ans3: "c", ans4: "a", ans5: "b", ans6: "b", ans7: "d",
        ans8: "e", ans9: "a", ans10: "c", ans11: "d", ans12: "b"
    });

    // HandleChange Input8
    const handleChange = (e) => {
        setAnswer8((prevProps) => ({
            ...prevProps,
            [e.target.name]: e.target.value
        }));
    }

    const submitHandler = async () => {
        showLoader();
        const response = await fetch(Constants.url + 'questions/question8', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token'))}`
            },
            body: JSON.stringify(answer8)
        });
        const result = await response.json();
        if (result.status === 'success') {
            history.push('/personalitytest')
            sessionStorage.setItem('Qpoints',JSON.stringify({q1p1:'1',q1p2:'1',q2:'1',q3:'1',q4:'1',q5:'1',q6:'1',q7:'1',pq:'0'}));
            hideLoader()
            toast.success(result.message);
        }
        else {
            hideLoader()
            toast.error(result.message);
            return false;
        }
    }

    useEffect(() => {
        setQuestion8(Questions['DBDA-RA'])
    },[])

    return (
        <Fragment>
            <div>
                <Typography variant="h6" color="inherit" >RA-Reasoning ability</Typography>
                <Timer initialMinute="5" initialSeconds="1" setDisableQuestion={setDisableQuestion} hideonCheck="0"></Timer>
                <Grid container direction="row" spacing={2} className="Questions row_base8">
                    {
                        question8.map((item, index) => (
                            <Fragment key={index} >
                                <Grid item xs={12} sm={3} md={3} lg={12}>
                                    <span className="me-5 dot">{item.id}.</span>
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label={`question${item.id}`} name={`question${item.id}`} value={answer8.question} onChange={handleChange}>
                                            <FormControlLabel value='a' control={<Radio />} label={item.a} disabled={disableQuestion} />
                                            <FormControlLabel value='b' control={<Radio />} label={item.b} disabled={disableQuestion} />
                                            <FormControlLabel value='c' control={<Radio />} label={item.c} disabled={disableQuestion} />
                                            <FormControlLabel value='d' control={<Radio />} label={item.d} disabled={disableQuestion} />
                                            <FormControlLabel value='e' control={<Radio />} label={item.e} disabled={disableQuestion} />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Fragment>
                        ))
                    }
                </Grid>
            </div>
            <div>
                <Fragment>
                    <Button variant="contained" color="primary" onClick={submitHandler}>
                        Next</Button>
                </Fragment>
            </div>
            {loader}
        </Fragment>
    )
});

const Question8 = React.memo(() => {

    return (
        <Quiz QuizCompo={QuizCompo}/>
    )
});

export default Question8
